/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FailedReservationOperation } from './FailedReservationOperation';
import {
    FailedReservationOperationFromJSON,
    FailedReservationOperationFromJSONTyped,
    FailedReservationOperationToJSON,
} from './FailedReservationOperation';

/**
 * 
 * @export
 * @interface UnscheduleBookableResponse
 */
export interface UnscheduleBookableResponse {
    /**
     * 
     * @type {Array<FailedReservationOperation>}
     * @memberof UnscheduleBookableResponse
     */
    failedReservations: Array<FailedReservationOperation>;
    /**
     * 
     * @type {number}
     * @memberof UnscheduleBookableResponse
     */
    cancelledCount: number;
    /**
     * 
     * @type {number}
     * @memberof UnscheduleBookableResponse
     */
    reassignedCount: number;
}

/**
 * Check if a given object implements the UnscheduleBookableResponse interface.
 */
export function instanceOfUnscheduleBookableResponse(value: object): value is UnscheduleBookableResponse {
    if (!('failedReservations' in value) || value['failedReservations'] === undefined) return false;
    if (!('cancelledCount' in value) || value['cancelledCount'] === undefined) return false;
    if (!('reassignedCount' in value) || value['reassignedCount'] === undefined) return false;
    return true;
}

export function UnscheduleBookableResponseFromJSON(json: any): UnscheduleBookableResponse {
    return UnscheduleBookableResponseFromJSONTyped(json, false);
}

export function UnscheduleBookableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnscheduleBookableResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'failedReservations': ((json['failedReservations'] as Array<any>).map(FailedReservationOperationFromJSON)),
        'cancelledCount': json['cancelledCount'],
        'reassignedCount': json['reassignedCount'],
    };
}

export function UnscheduleBookableResponseToJSON(value?: UnscheduleBookableResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'failedReservations': ((value['failedReservations'] as Array<any>).map(FailedReservationOperationToJSON)),
        'cancelledCount': value['cancelledCount'],
        'reassignedCount': value['reassignedCount'],
    };
}

